/**
 * Injeta as cores do tema como CSS custom properties no :root.
 * Assim o mesmo tema é usado em JS e em SCSS (var(--main-6), etc.).
 * Chamar uma vez no bootstrap da app (ex: index.js).
 * @param {Object} theme - Objeto theme (ou outro tema com mesma estrutura)
 * @param {string} prefix - Prefixo das variáveis (default: vazio)
 */
export const injectCssVars = (theme, prefix = "") => {
  if (typeof document === "undefined" || !document.documentElement) return;

  const root = document.documentElement;
  const setVar = (name, value) => {
    if (typeof value === "string" && value) root.style.setProperty(`--${prefix}${name}`, value);
  };

  const scaleKeys = ["grayScale", "mainColors", "secondaryColors"];
  scaleKeys.forEach((groupKey) => {
    const group = theme[groupKey];
    if (!group || typeof group !== "object") return;
    const cssKey = groupKey.replace("Colors", "").replace("Scale", "");
    Object.keys(group).forEach((level) => setVar(`${cssKey}-${level}`, group[level]));
  });

  const auxiliary = theme.auxiliaryColors;
  if (auxiliary && typeof auxiliary === "object") {
    Object.keys(auxiliary).forEach((colorName) => {
      const scale = auxiliary[colorName];
      if (scale && typeof scale === "object") {
        Object.keys(scale).forEach((level) =>
          setVar(`auxiliary-${colorName}-${level}`, scale[level])
        );
      }
    });
  }
}
